const SECTIONS: Array<string> = ["Shift Notes"];

// Define which sections should be visible by default for a note.
const useNoteSectionVisibility = (property: string | null): string[] => {
  if (property === null || property === undefined) return [];

  if (property) {
    return SECTIONS;
  }

  return [];
};

export default useNoteSectionVisibility;
